import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { MatMenu } from "@angular/material/menu";
import { Subject } from "rxjs";

@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})

export class TabsComponent implements OnInit,OnDestroy {
  isTable:boolean=false;
  @Input() tabs: { name: string; amount: number }[];
  @Input() actionText: string;
  @Input() showUploadBulk:boolean=false;
  @Output() actionEvent: EventEmitter<string> = new EventEmitter();
  @Output() uploadBulkEvent: EventEmitter<string> = new EventEmitter();
  @Output() isTableView: EventEmitter<string> = new EventEmitter();
  @Input() isShipmentList:boolean = false;
  @Input() exportMenu: MatMenu;
  private destroy$ = new Subject<void>();
  
  constructor() {}

  ngOnInit(): void {
     this.isTable = localStorage.getItem("ShipmentTableView")
     ? localStorage.getItem("ShipmentTableView") == "true" : false;
  }

  actionClicked(e?) {
    this.actionEvent.emit(e);
  }

  cancelPropergation(e: MouseEvent) {
    e.stopPropagation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  changeToggle(event){
    this.isTableView.emit(event.checked);
  }

}
